import { AuditLiveMention } from '@mi-front/core';
import FlagIcon from '@mui/icons-material/Flag';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { LTime } from '../../../../../../../../../components/date/LTime';
import { Pre, SubTitle, Title, Wrapper } from './elements';
import { LiveMentionConfidenceControls } from './LiveMentionConfidenceControls';
import { LiveMentionPlayBtn } from './LiveMentionPlayBtn';
import { LiveMentionShowButton } from './LiveMentionShowButton';
import { LiveShareBtn } from './LiveShareButton';

const MAX_LENGTH = 100;

export function LiveMentionInfo({ liveMention }: { liveMention: AuditLiveMention }) {
  const { stationId, id, datetime, name, description } = liveMention;
  const [isExpanded, setIsExpanded] = useState(false);
  const descriptionText = description ? description : '';
  const { formatMessage } = useIntl();
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const shouldShowButton = descriptionText.length > MAX_LENGTH;
  const displayedDescriptionText =
    isExpanded || !shouldShowButton
      ? description
      : descriptionText.substring(0, MAX_LENGTH) + '...';

  return (
    <Wrapper>
      <>
        <Pre>
          {formatMessage({
            id: 'logger.streamScreen.audit.liveMentionLabel',
            defaultMessage: 'Mención en vivo de auditoría',
          })}
        </Pre>
        <Title>{name}</Title>
        <SubTitle>
          {displayedDescriptionText}
          {shouldShowButton && !isExpanded && (
            <Button
              sx={{ paddingBottom: '0.5rem' }}
              size="small"
              onClick={toggleExpanded}
              variant="text"
            >
              {formatMessage({
                id: 'logger.streamScreen.audit.showMore',
                defaultMessage: 'Ver más',
              })}
            </Button>
          )}
        </SubTitle>
      </>
      <div>
        <FlagIcon sx={{ fontSize: 'inherit', verticalAlign: 'middle' }} />{' '}
        <LTime value={datetime} />
      </div>
      <LiveMentionConfidenceControls stationId={stationId} id={id} />
      <LiveMentionPlayBtn liveMention={liveMention} />
      <LiveShareBtn liveMention={liveMention} />
      <LiveMentionShowButton liveMention={liveMention} />
    </Wrapper>
  );
}
